import angular from 'angular';
import dashboardIframeDirective from './dashboard-iframe.directive';

export default angular.module('app.components.dashboard.iframe', [])
  .directive('dashboardIframe', dashboardIframeDirective)
  .name;

console.log('app.components.global.dashboard.iframe created');
